import axios from 'axios';
import { WorkPhaseForm } from '../models/investors';

export interface WorkPhaseProgressPayload {
  phase_progress: number;
}

const loadAbort = () => new AbortController();

export const getWorkPhasesEndpoint = (projectId: string, token: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/work-phases`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const createWorkPhaseEndpoint = (
  projectId: string,
  payload: WorkPhaseForm,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'POST',
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/work-phases`,
        data: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const updateWorkPhaseProgressEndpoint = (
  projectId: string,
  phaseId: string,
  payload: WorkPhaseProgressPayload,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'PATCH',
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/work-phases/${phaseId}/progress`,
        data: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};
